import axios from "axios"
import { GET_POSTAL_REQUEST, SET_ADDRESS } from "./types"
import { GET_POSTAL_SUCCESS } from "./types"
import { GET_POSTAL_FAIL } from "./types"
import { GET_OUTLET_DETAILS } from "./types"
import { GET_OUTLET_DETAILS_FAIL } from "./types"
import { GET_OUTLET_DETAILS_SUCCESS } from "./types"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    isOwnDelivery,
    buildOwnDeliveryOutlets,
    LALAMOVE_QUOTE_URL
} from "../utils/deliveryMode";


let timer = null

export const requestPostal = () => {
    return {
        type: GET_POSTAL_REQUEST
    }
}

export const requestPostalSuccess = (data) => {
    return {
        type: GET_POSTAL_SUCCESS,
        payload: data
    }
}

export const requestPostalFail = (error) => {
    return {
        type: GET_POSTAL_FAIL,
        payload: error
    }
}


export const getPostal = (postal) => (dispatch) => {
    dispatch(requestPostal());

    if (timer) {
        clearTimeout(timer)
    }

    timer = setTimeout(() => {
        // fetch(`https://developers.onemap.sg/commonapi/search?searchVal=${postal}&returnGeom=Y&getAddrDetails=Y&pageNum=1`).then(function(response) {
        fetch(`https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${postal}&returnGeom=Y&getAddrDetails=Y&pageNum=1`).then(function (response) {
            return response.json();
        }).then(function (data) {
            dispatch(requestPostalSuccess(data));
        }).catch(function (error) {
            dispatch(requestPostalFail(error));
        });
    }, 500)



    // axios.get(`https://developers.onemap.sg/commonapi/search?searchVal=${postal}&returnGeom=Y&getAddrDetails=Y&pageNum=1`).then((response)=>{
    //     dispatch(requestPostalSuccess(response.data))
    // }).catch((error)=>{
    //     dispatch(requestPostalFail(error))
    // })
}

export const getOutletInformation = (data) => (dispatch, getState) => {
    dispatch({
        type: GET_OUTLET_DETAILS
    })

    // DEL-1 :: OWN DELIVERY NEVER ASKS LALAMOVE FOR A QUOTATION. THE OUTLET LIST COMES FROM
    // THE BUSINESS LOCATIONS ALREADY IN THE STORE AND THE FEE IS QUOTED FROM THE CART AT CHECKOUT
    if (isOwnDelivery()) {
        const businessLocations = getState()?.products?.outlates?.business_location
        dispatch({
            type: GET_OUTLET_DETAILS_SUCCESS,
            payload: { status: 200, data: buildOwnDeliveryOutlets(businessLocations) }
        })
        return
    }

    axios.post(LALAMOVE_QUOTE_URL, {
        "business_id": localStorage.getItem("business_id"),
        "cust_lat": data.latitude ?? 0,
        "cust_lng": data.longtitude ?? 0,
        "cust_add": data.full_address,
        "cust_name": data.customer_name,
        "cust_phone": data.customer_phone,
        "cust_remark": data.customer_remark || ""
    }).then((response) => {
        if (response.data && response.status === 200) {
            dispatch({
                type: GET_OUTLET_DETAILS_SUCCESS,
                payload: response
            })

        } else {
            dispatch({
                type: GET_OUTLET_DETAILS_FAIL,
                payload: 'Something went wrong'
            })
        }

    }).catch((error) => {
    //   toast.error(error.message || "Failed to get outlet details");
    if(error.response && error.response.data && error.response.data.message){
        toast.error(error.response.data.message);
    } else {
        toast.error("Failed to get outlet details");
    }
        dispatch({
            type: GET_OUTLET_DETAILS_FAIL,
            payload: error
        })
    })
}



